import { appService } from "/app/src/services";
import Hue from "./hue";
import { App as AppType } from "/app/src/models";
import { useNumberId } from "/app/src/hooks/useNumberId";
import { useQuery } from "@tanstack/react-query";
import Box from "/app/src/components/generic/components/box";
import DataPull from "./dataPull";

/**
 * This function serves as the main application component that loads and renders app settings.
 *
 * @returns {JSX.Element} The JSX element representing the rendered app.
 */
export default function App() {
  const params = useNumberId();

  const { data: app } = useQuery({
    queryKey: ["app", params.appId],
    queryFn: () => {
      return appService.getSingle(params.appId);
    },
    enabled: Boolean(params.appId),
    initialData: { app: {} },
    select: (data: { app: AppType }) => {
      return data.app;
    },
  });

  return (
    <div className="appSettings">
      <Box>
        {app.name === "Philips Hue" && <Hue app={app} />}
        {app.name === "Data Pull" && <DataPull app={app} />}
      </Box>
    </div>
  );
}
